import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import * as style from "./style.module.css"
import Map from "/src/components/Map"
import json from "/src/siteData.json"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"
import logo from "/src/images/common/logo.svg"

const data = json.footer
const logoUri = json.header.logoUri
const siteMetaData = json.siteMetadata

const Component = () => {
  return (
    <>
      <Map address={data.address} />
      <footer>
        <div className={style.footerTopWrapper}>
          <img src={logo} alt="株式会社新翔" />
          <span>株式会社　新翔</span>
        </div>
        <div className={style.footerBottomWrapper}>
          <div className={style.footerLink}>
            <h2>+採用情報</h2>
            <Link to="/work/work-scaffold-full">-とび職×正社員</Link>
            <Link to="/work/work-scaffold-part">-とび職×アルバイト・パート</Link>
            <Link to="/work/work-scaffold-sub">-とび職×業務委託</Link>
            <Link to="/advantage">-新翔のアドバンテージ</Link>
            <Link to="/staff">-社員紹介</Link>
            <Link to="/qaa">-よくある質問</Link>
          </div>

          <div className={style.footerLink}>
            <h2>+事業内容</h2>
            <Link to="/business/low-rise-scaffold">-低層足場</Link>
            <Link to="/business/middle-high-rise-scaffold">-中高層足場</Link>
            <Link to="/business/special-scaffold">-特殊足場</Link>
          </div>

          <div className={style.footerLink}>
          <Link to="/flow"><h2>-取引の流れ</h2></Link>
          </div>

          <div className={style.footerLink}>
          <Link to="/articles/p/1"><h2>-お知らせ</h2></Link>
          </div>

          <div className={style.footerLink}>
          <Link to="/about"><h2>-会社情報</h2></Link>
          </div>

          <div className={style.footerLink}>
          <Link to="/contact"><h2>-お問い合わせ</h2></Link>
          </div>
        </div>

<div className={style.privacyPolicyWrapper}>
        <Link to="/privacy-policy">プライバシーポリシー</Link>
        </div>

        <div className={style.allrightsreservedWrapper}>
          © 株式会社　新翔. All rights reserved.
        </div>
      </footer>
    </>
  )
}

export default Component
